export class IntegrationConfigEnvelope {
  current: IntegrationConfigBase = new IntegrationConfigBase();

  history: IntegrationConfigHistoryItem[] = [];
}

export class IntegrationConfigBase {}

export class IntegrationConfigHistoryItem {
  meta: IntegrationConfigAuditMeta = new IntegrationConfigAuditMeta();

  snapshot: IntegrationConfigBase = new IntegrationConfigBase();
}

export class IntegrationConfigAuditMeta {
  modified: string = '';

  modifiedBy: string = '';

  modifiedById: string = '';
}
